"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTheme = createTheme;
exports.defaultTheme = void 0;
exports.generateColorVariants = generateColorVariants;
exports.generatePrimitives = generatePrimitives;
exports.shade = shade;
exports.tint = tint;
exports.useStyletron = void 0;

var _baseui = require("baseui");

var _color = _interopRequireDefault(require("color"));

var _colors = require("./colors");

var _typography = require("./typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tint(color, factor) {
  return (0, _color.default)(color).mix((0, _color.default)('white'), factor / 100).hex();
}

function shade(color, factor) {
  return (0, _color.default)(color).mix((0, _color.default)('black'), factor / 100).hex();
}

function generateColorVariants(name, color) {
  if (!name || !color) return {};
  const tintFactors = [20, 50, 80, 90];
  const shadeFactors = [25, 40, 60];
  return {
    [`${name}50`]: tint(color, tintFactors[3]),
    [`${name}100`]: tint(color, tintFactors[2]),
    [`${name}200`]: tint(color, tintFactors[1]),
    [`${name}300`]: tint(color, tintFactors[0]),
    [`${name}400`]: color,
    [name]: color,
    [`${name}500`]: shade(color, shadeFactors[0]),
    [`${name}600`]: shade(color, shadeFactors[1]),
    [`${name}700`]: shade(color, shadeFactors[2])
  };
}

function generatePrimitives({
  accent = _colors.greys.grey50,
  primary = '#0073bf',
  // belize-hole
  negative = '#f26335',
  //cayenne
  warning = '#e7b41a',
  // egg-yolk
  positive = '#27ae60',
  // nephritis
  fontFamily = _typography.BASE_FONT_FAMILY
} = {}) {
  const baseColors = {
    accent,
    primary,
    negative,
    warning,
    positive
  };
  const mainColors = Object.entries(baseColors).reduce((accum, [name, baseColor]) => {
    const colors = generateColorVariants(name, baseColor);
    return { ...accum,
      ...colors
    };
  }, {}); // Specific values from the styleguide
  // We also provide the greyXX aliases

  const greys = { ..._colors.greys,
    mono100: _colors.greys.white,
    mono200: _colors.greys.grey10,
    mono300: _colors.greys.grey20,
    mono400: _colors.greys.grey30,
    mono500: _colors.greys.grey40,
    mono600: _colors.greys.grey50,
    mono700: _colors.greys.grey60,
    mono800: _colors.greys.grey70,
    mono900: _colors.greys.grey90,
    mono1000: _colors.greys.black
  }; // @ts-ignore: This is correct

  return { ...mainColors,
    ...greys,
    rating200: '#FFE1A5',
    rating400: '#FFC043',
    primaryFontFamily: fontFamily
  };
}

function createTheme(baseTheme = {}, overrides = {}) {
  const primitives = generatePrimitives(baseTheme);
  const combinedOverrides = {
    typography: _typography.fonts,
    colors: { ..._colors.greys,
      notificationInfoBackground: primitives.primary50,
      notificationInfoText: primitives.primary500,
      toastInfoBackground: primitives.primary50,
      toastInfoText: primitives.primary500
    },
    ...overrides
  };
  const theme = (0, _baseui.createTheme)(primitives, { ...combinedOverrides
  }); // There's currently no way to parameterize createTheme, so just force it

  return theme;
}

const useStyletron = (0, _baseui.createThemedUseStyletron)();
exports.useStyletron = useStyletron;
const defaultTheme = createTheme();
exports.defaultTheme = defaultTheme;